import API from './api';

// create stream
export const createStream = async (formData) => {
  try {
    const res = await API.post('/stream', formData);
    return res.data;
  } catch (err) {
    throw err;
  }
};

// end stream
export const endStream = async () => {
  try {
    const res = await API.put(`/stream`);
    return res.data;
  } catch (err) {
    throw err;
  }
};

// go live
export const goLive = async () => {
  try {
    const res = await API.put('/stream/go-live');
    return res.data;
  } catch (err) {
    throw err;
  }
};
